<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div class="vx-card p-6">
		<div class="flex flex-wrap items-center justify-end">
			<!-- ITEMS PER PAGE -->
			<div class="flex-grow">
				<vs-dropdown vs-trigger-click class="cursor-pointer">
					<div
						class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
					>
						<span class="mr-2"
							>{{
								paginationPageSize === 0
									? 0
									: currentPage * paginationPageSize - (paginationPageSize - 1)
							}}
							-
							{{
								optimizationData.length - currentPage * paginationPageSize > 0
									? currentPage * paginationPageSize
									: optimizationData.length
							}}
							{{ $t("Of") }} {{ pagination.total_records }}</span
						>
						<feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
					</div>
					<vs-dropdown-menu style="z-index: 55000">
						<vs-dropdown-item @click="paginationSetPageSize(20)">
							<span>20</span>
						</vs-dropdown-item>
						<vs-dropdown-item @click="paginationSetPageSize(50)">
							<span>50</span>
						</vs-dropdown-item>
						<vs-dropdown-item @click="paginationSetPageSize(100)">
							<span>100</span>
						</vs-dropdown-item>
						<vs-dropdown-item @click="paginationSetPageSize(200)">
							<span>200</span>
						</vs-dropdown-item>
					</vs-dropdown-menu>
				</vs-dropdown>
			</div>
			<template>
				<!-- ITEMS PER PAGE -->
				<div>
					<vs-dropdown vs-trigger-click class="cursor-pointer">
						<div
							class="p-3 mt-1 mr-2 border border-solid d-theme-border-grey-light rounded-lg d-theme-dark-bg cursor-pointer font-medium"
						>
							<span class="mr-2">{{ $t("SearchBy") }} {{ searchSelected }}</span>
							<feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
						</div>
						<vs-dropdown-menu style="z-index: 55000">
							<vs-dropdown-item @click="setSearchField('Id')">
								<span>Id</span>
							</vs-dropdown-item>
							<vs-dropdown-item @click="setSearchField('Name')">
								<span>{{ $t("Name") }}</span>
							</vs-dropdown-item>
							<vs-dropdown-item @click="setSearchField('RoutingTypeSearch')">
								<span>{{ $t("RoutingTypeSearch") }}</span>
							</vs-dropdown-item>
							<vs-dropdown-item @click="setSearchField('OptimizationGroup')">
								<span>{{ $t("OptimizationGroup") }}</span>
							</vs-dropdown-item>
							<vs-dropdown-item v-if="!showInPopup" @click="setSearchField('State')">
								<span>{{ $t("State") }}</span>
							</vs-dropdown-item>
						</vs-dropdown-menu>
					</vs-dropdown>
				</div>
			</template>
			<div class="vx-col md:w-1/3 sm:w-1/2 w-full p-0" v-if="searchFieldSelected">
				<div class="vx-row">
					<div class="vx-col w-full">
						<v-select
							v-model="infoSelected"
							class="w-full"
							multiple
							:clearable="false"
							:options="arrayInfo"
							:dir="$vs.rtl ? 'rtl' : 'ltr'"
							:placeholder="$t('Select') + ' ' + searchSelected"
						>
							<template v-slot:no-options="{search, searching}">
								<template v-if="searching">
									{{ $t("NoResultsFoundFor") + " " }}<em>{{ search }}</em>
								</template>
								<template v-else>
									{{ $t("NoResultsFound") }}
								</template>
							</template>
						</v-select>
					</div>
				</div>
			</div>
			<div v-else class="vx-col md:w-1/3 sm:w-1/2 w-full p-0">
				<vx-tooltip
					class="cursor-pointer"
					color="primary"
					position="bottom"
					delay=".1s"
					:title="$t('Search')"
					:text="$t('SearchSeparatedByCommas') + '.'"
				>
					<tags-input
						element-id="tags"
						v-model="searchQuery"
						add-tags-on-comma
						add-tags-on-blur
						:placeholder="$t('Teams.Form.Add') + ' ' + searchSelected"
						:typeahead="true"
						@keyup.enter="search"
					></tags-input>
				</vx-tooltip>
			</div>
			<vs-button
				class="ml-2"
				color="primary"
				icon-pack="feather"
				icon="icon-search"
				:title="$t('VisitPoints.Search')"
				@click.prevent="search"
			></vs-button>
			<vs-button
				class="ml-2 mr-2"
				color="primary"
				icon-pack="feather"
				icon="icon-refresh-cw"
				:title="$t('Refresh')"
				@click.prevent="refresh()"
			></vs-button>
			<vs-button
				v-if="!showInPopup"
				class="mr-2"
				color="primary"
				icon-pack="feather"
				icon="icon-plus"
				:title="$t('Optimization.CreateOptimization')"
				@click.prevent="$router.push('/dashboard/optimization')"
			></vs-button>
			<vs-dropdown
				vs-custom-content
				:vs-trigger-click="true"
				class="cursor-pointer"
				:title="$t('Setting.Setting')"
			>
				<vs-button type="filled" icon-pack="feather" icon="icon-settings"></vs-button>
				<vs-dropdown-menu style="z-index: 54000; width: 30%">
					<vx-card no-shadow :title="$t('Setting.Setting')">
						<div class="flex flex-row justify-between p-1">
							<p class="mr-2">{{ $t("Preferences.FindExactly") }}</p>
							<vs-switch color="success" v-model="isExactly" @input="openEnableConfirm"></vs-switch>
						</div>
					</vx-card>
				</vs-dropdown-menu>
			</vs-dropdown>
		</div>
		<!-- AgGrid Table -->
		<ag-grid-vue
			ref="agGridTable"
			class="ag-theme-material w-100 my-4 ag-grid-table"
			:class="[{'ag-customizer-container': !isWidthPortatil}]"
			colResizeDefault="shift"
			:components="components"
			:gridOptions="gridOptions"
			:columnDefs="columnDefs"
			:defaultColDef="defaultColDef"
			:rowData="optimizationData"
			:animateRows="true"
			:pagination="true"
			:paginationPageSize="paginationPageSize"
			:suppressPaginationPanel="true"
			:enableRtl="$vs.rtl"
			:overlayNoRowsTemplate="overlayNoRowsTemplate"
			:overlayLoadingTemplate="overlayLoadingTemplate"
			:enableCellTextSelection="true"
		>
		</ag-grid-vue>
		<vs-pagination :total="totalPages" :max="7" v-model="currentPage" />
	</div>
</template>

<script>
import {OptimizationListMixin} from "../optimization/model/OptimizationListMixin";

export default {
	mixins: [OptimizationListMixin],
};
</script>

<style lang="scss" scoped>
#page-user-list {
	.user-list-filters {
		.vs__actions {
			position: absolute;
			right: 0;
			top: 50%;
			transform: translateY(-58%);
		}
	}
}
.add-new-data-sidebar {
	::v-deep .vs-sidebar--background {
		z-index: 51010;
		background-color: rgba(0, 0, 0, 0.7);
	}

	::v-deep .vs-sidebar {
		z-index: 51010;
		width: 450px;
		max-width: 90vw;

		.img-upload {
			margin-top: 2rem;

			.con-img-upload {
				padding: 0;
			}

			.con-input-upload {
				width: 100%;
				margin: 0;
			}
		}
	}
}
</style>
